import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M105.15 59.49c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M89.76 39.86a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M14.92 62.41a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M18.54 88l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12L14.3 88l-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM93.76 15.03h-5.57V9.46c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#0597A3"
      d="M89.07 62.42V82.1c0 1.1-.89 2-1.99 2H41.74c-6.53 0-11.83-5.3-11.83-11.83s5.3-11.83 11.83-11.83h45.34c1.1 0 1.99.89 1.99 1.99z"
    />
    <path
      fill="#00D8D8"
      d="m85.55 51.86 4.48 18.61c.29 1.22-.46 2.44-1.67 2.73L44.55 83.76c-6.35 1.53-12.75-2.38-14.28-8.73S32.65 62.28 39 60.75l43.81-10.56c1.22-.29 2.44.46 2.73 1.67z"
    />
    <path
      fill="#D8FFFF"
      d="m43.95 23.97 18.67 4.69c1.18.3 1.9 1.5 1.61 2.68l-11 43.76c-1.59 6.33-8.03 10.18-14.36 8.59s-10.18-8.03-8.59-14.36l11-43.76c.3-1.18 1.5-1.9 2.68-1.61z"
    />
    <path
      fill="#00D8D8"
      d="M41.08 75.72a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86"
    />
  </svg>
);
const SvgEnrichedIconSelectionsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSelectionsBrand);
export default Memo;
